// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2ovjr","footer":"ModalFilter_footer__37oXA"};